/*
 * @Author: Merlin
 * @Date: 2024-01-25 13:16:24
 * @LastEditors: Merlin
 * @LastEditTime: 2025-05-02 10:23:10
 * @Description: 
 */

// ↓ 深拷贝 
export function deepCopy(theObj){
    if (!theObj) return theObj;
    if (Array.isArray(theObj)){
        return theObj.map(item => deepCopy(item));
    }
    const hasFn = typeof structuredClone === 'function'; 
    let oRaw;
    try{
        oRaw = toRaw(theObj);
        return (
            hasFn
            ? structuredClone(oRaw)
            : JSON.parse(JSON.stringify(oRaw))
        );
    } catch(err){
        oRaw = oRaw || theObj;
        hasFn && console.log('无法克隆\n', oRaw);
        return JSON.parse(JSON.stringify(oRaw));
    }
}


// 取得特定区间的随机数（浮点）
export function getRandomFloat(min, max) {
    const step1 = Math.random() * (max - min);
    return step1 + min;
}


// 取得特定区间的随机数（整数，包含 max 值)
export function getRandomInt(min, max) {
    // ↓ 如果入参为 1, 10 则 step1 的值为：0 - 9
    // ↓ 如果入参为 3, 10 则 step1 的值为：0 - 7
    const step1 = Math.floor(
        Math.random() * (max - min + 1)
    );
    return step1 + min; // 最终的可能性为 1-10
}
/**
 * 节流方法
 * @param func 需要执行的方法
 * @param delay 多少时间(ms)后执行一次
 * @param immediate 是否立即执行
 * @returns 处理后的方法
 */
/**
 * 防抖方法
 * @param func 需要执行的方法
 * @param delay 延迟时间(ms)
 * @param immediate 是否立即执行（首次触发立即执行，之后在 delay 内不再触发）
 */
export function debounce(func, delay, immediate = false) {
    let timer: ReturnType<typeof setTimeout> | null = null;
    return function(...args) {
        if (timer) clearTimeout(timer);
        if (immediate && !timer) {
            func.apply(this, args);
            timer = setTimeout(() => { timer = null; }, delay);
        } else {
            timer = setTimeout(() => {
                func.apply(this, args);
                timer = null;
            }, delay);
        }
    };
}

export function throttle(func, delay, immediate = false) {
    let lastCall = 0;
    return function(...args) {
        const now = Date.now();
        if (immediate && lastCall === 0) {
            lastCall = now;
            return func.apply(this, args); // 立即执行
        }
        if (now - lastCall >= delay) {
            lastCall = now;
            return func.apply(this, args);
        }
    };
}



